export default __webpack_public_path__ + "static/media/Eggheadio.6a8474cc.svg";